import { useState } from 'react';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { SiteHeader } from './components/SiteHeader';
import { SlateGallery } from './components/SlateGallery';
import { BronzeSection } from './components/BronzeSection';
import { SelectWork } from './components/SelectWork';
import { ServiceSection } from './components/ServiceSection';
import { Contact, SiteFooter } from './components/Contact';
import { ContactModal } from './components/ContactModal';
import { SkipLink } from './components/SkipLink';
import { HeadMetaTags } from './components/HeadMetaTags';
import { ContentProvider, useSite } from './content';

export function App() {
  return (
    <ContentProvider>
      <AppShell />
    </ContentProvider>
  );
}

function AppShell() {
  const site = useSite();
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [initialInquiry, setInitialInquiry] = useState<string | undefined>(undefined);
  const openContact = (inquiryType?: string) => {
    setInitialInquiry(inquiryType);
    setIsContactOpen(true);
  };
  const closeContact = () => setIsContactOpen(false);

  return (
    <>
      <HeadMetaTags />
      <SkipLink />
      <SiteHeader onOpenContact={openContact} />
      <main
        id="main-content"
        className="w-full min-h-screen bg-slate-dark selection:bg-bronze selection:text-white"
      >
        <Hero onOpenContact={openContact} />
        <About />
        <SlateGallery />
        <BronzeSection />

        {site.services.map((service) => (
          <ServiceSection
            key={service.id}
            id={service.id}
            title={service.title}
            reverse={service.reverse}
            imageUrl={service.backgroundImageUrl}
            imageAlt={service.backgroundAlt}
            intro={service.intro}
            bulletHeading={service.bulletHeading}
            bullets={service.bullets}
            contactLabel={service.contactLabel}
            onOpenContact={openContact}
          />
        ))}

        <SelectWork onOpenContact={openContact} />

        <Contact onOpenContact={openContact} />
      </main>
      <SiteFooter />
      <ContactModal
        isOpen={isContactOpen}
        onClose={closeContact}
        initialInquiryType={initialInquiry}
      />
    </>
  );
}
